// extracted by mini-css-extract-plugin
module.exports = {"icon":"mf-DG","root":"mf-Pg","trigger":"mf-Ph"};